import { render, staticRenderFns } from "./curationMailPad.vue?vue&type=template&id=40459e35&scoped=true&"
import script from "./curationMailPad.vue?vue&type=script&lang=js&"
export * from "./curationMailPad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40459e35",
  null
  
)

export default component.exports